import { maxValue, minValue, normalName, required } from '@/validation'

export const createStepValidationRules = {
    name: { required, normalName },
    stepTypeId: { required },
    durationInSeconds: { max: maxValue(32767), min: minValue(0) },
  }
